type FloodingLocales = {
  places: { [key: string]: { label: string } }
  labels: { [key: string]: string }
}
export const Flooding_DE: FloodingLocales = {
  places: {
    NewYork: { label: 'New York' },
    Amsterdam: { label: 'Amsterdam' },
    Venedig: { label: 'Venedig' },
    Bangladesh: { label: 'Bangladesh' },
    London: { label: 'London' },
    Lissabon: { label: 'Lissabon' },
  },
  labels: {
    floodLevelRise: 'Meerespiegelanstieg',
    source: 'Quelle: United States Geological Survey',
    floodHint: 'Anstieg auswählen',
    placeHint: 'Ort auswählen',
  },
}

export const Flooding_FR: FloodingLocales = {
  places: {
    NewYork: { label: 'FR_New York' },
    Amsterdam: { label: 'FR_Amsterdam' },
    Venedig: { label: 'FR_Venedig' },
    Bangladesh: { label: 'FR_Bangladesh' },
    London: { label: 'FR_London' },
    Lissabon: { label: 'FR_Lissabon' },
  },
  labels: {
    floodLevelRise: 'FR_Meerespiegelanstieg',
    source: 'FR_Quelle: United States Geological Survey',
    floodHint: 'FR_Anstieg auswählen',
    placeHint: 'FR_Ort auswählen',
  },
}
